import { render, staticRenderFns } from "./FreeRoomLog.vue?vue&type=template&id=53c933ff&lang=pug&"
import script from "./FreeRoomLog.vue?vue&type=script&lang=ts&"
export * from "./FreeRoomLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports